import { render, staticRenderFns } from "./ResidentPaymentHistory.vue?vue&type=template&id=0531a1e9&scoped=true&"
import script from "./ResidentPaymentHistory.vue?vue&type=script&lang=ts&"
export * from "./ResidentPaymentHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531a1e9",
  null
  
)

export default component.exports